import { render, staticRenderFns } from "./CitiesFeedWidget.vue?vue&type=template&id=847f1a16&"
import script from "./CitiesFeedWidget.vue?vue&type=script&lang=js&"
export * from "./CitiesFeedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('847f1a16')) {
      api.createRecord('847f1a16', component.options)
    } else {
      api.reload('847f1a16', component.options)
    }
    module.hot.accept("./CitiesFeedWidget.vue?vue&type=template&id=847f1a16&", function () {
      api.rerender('847f1a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/CitiesFeedWidget.vue"
export default component.exports